var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth__side",class:{ 'auth-side-key': _vm.getAuthKeyRoute }},[_c('keep-alive',[_c(_vm.authSideComponent,{tag:"component"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }